module.exports = __webpack_public_path__ + "static/media/8900_Front3.ce3ba4d7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/GalleryPhotos/8900_Front3.jpg
// module id = 577
// module chunks = 0